import React from 'react';
import styled from 'styled-components';

const Div = styled.div`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  color: white;
  width: 100%;
  font-size: 0.6rem;
  &.active {
    display: flex;
    opacity: 1;
  }

  .progress-bar {
    position: relative;
    height: 1rem;
    width: 100%;
    border-radius: 1rem;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0 8px 10px 0px rgba(255, 255, 255, 0.2);
    margin: 0.6rem 0 1.2rem;
  }

  .filler {
    display: flex;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    height: 100%;
    border-radius: inherit;
    transition: width 0.4s ease-in;
    opacity: 1;
  }

  .title {
    letter-spacing: 2px;
    font-weight: 600;
    text-align: center;
  }

  .text {
    display: flex;
    align-items: flex-end;
    &--percentage {
      font-size: 1rem;
      font-weight: 600;
      margin-right: 0.5rem;
    }
  }
`;

const ProgressBar = (props) => {
  const { isOpen, title, completed } = props;

  return (
    <Div className={isOpen ? 'active' : ''}>
      <div className="title">{title}</div>
      <div className="progress-bar">
        <div className="filler" style={{ width: `${isOpen ? completed : null}%` }} />
      </div>
      <div className="text">
        <div className="text--percentage">{completed}</div>%
      </div>
    </Div>
  );
};

ProgressBar.defaultProps = {
  isOpen: false,
  title: null,
  completed: 0,
};

export default ProgressBar;
